<template>

    <router-view class="main-wrapper"></router-view>
  
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
@import '@/styles/variables'; 
@import 'bootstrap/scss/bootstrap.scss';

.main-wrapper {
    // background-color: $body-tertiary-bg;
    position: relative;
    background-image: url('@/assets/layered-waves-haikei (15).svg');
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
}

@include color-mode(dark) {
    .main-wrapper {
        // background-color: $body-tertiary-bg-dark; 
        background-image: url('@/assets/layered-waves-haikei (16).svg');
    }
}
</style>